export default __webpack_public_path__ + "static/media/eau1.dbceadae.jpg";